import * as angular from 'angular';

export class GdprFactory {
    private apiRoot: string = '/api/v1/gdpr';
    private $http;

    constructor($http) {
        this.$http = $http;
    }

    getAgreementsToAccept() {
        return this.$http.get(
            `${this.apiRoot}/company_agreements/`
        );
    }

    acceptAgreement(agreement: any) {
        return this.$http.post(
            `${this.apiRoot}/agreement_acceptance/`,
            agreement
        );
    }
}

angular
    .module('app')
    .service('GdprFactory', GdprFactory);



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/services/gdpr.factory.ts